export default {
  title: 'Project Type Report',
  backButton: 'All reports',
  adminBackButton: 'Back to MBD Reports',
};
